function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { CalendarDate as $35ea8db9cb2ccb90$export$99faa760c7908e4f } from "./CalendarDate.module.js";
import { GregorianCalendar as $3b62074eb05584b2$export$80ee6245ec4f29ec } from "./GregorianCalendar.module.js";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.

var $62225008020f0a13$var$ERA_START_DATES = [[1868, 9, 8], [1912, 7, 30], [1926, 12, 25], [1989, 1, 8], [2019, 5, 1]];
var $62225008020f0a13$var$ERA_END_DATES = [[1912, 7, 29], [1926, 12, 24], [1989, 1, 7], [2019, 4, 30]];
var $62225008020f0a13$var$ERA_ADDENDS = [1867, 1911, 1925, 1988, 2018];
var $62225008020f0a13$var$ERA_NAMES = ['meiji', 'taisho', 'showa', 'heisei', 'reiwa'];
function $62225008020f0a13$var$findEraFromGregorianDate(date) {
  var idx = $62225008020f0a13$var$ERA_START_DATES.findIndex(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
      year = _ref2[0],
      month = _ref2[1],
      day = _ref2[2];
    if (date.year < year) return true;
    if (date.year === year && date.month < month) return true;
    if (date.year === year && date.month === month && date.day < day) return true;
    return false;
  });
  if (idx === -1) return $62225008020f0a13$var$ERA_START_DATES.length - 1;
  if (idx === 0) return 0;
  return idx - 1;
}
function $62225008020f0a13$var$toGregorian(date) {
  var eraAddend = $62225008020f0a13$var$ERA_ADDENDS[$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
  if (!eraAddend) throw new Error('Unknown era: ' + date.era);
  return new (0, $35ea8db9cb2ccb90$export$99faa760c7908e4f)(date.year + eraAddend, date.month, date.day);
}
var $62225008020f0a13$export$b746ab2b60cdffbf = /*#__PURE__*/function (_ref3) {
  function $62225008020f0a13$export$b746ab2b60cdffbf() {
    var _this;
    _classCallCheck(this, $62225008020f0a13$export$b746ab2b60cdffbf);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, $62225008020f0a13$export$b746ab2b60cdffbf, [].concat(args)), _this.identifier = 'japanese';
    return _this;
  }
  _inherits($62225008020f0a13$export$b746ab2b60cdffbf, _ref3);
  return _createClass($62225008020f0a13$export$b746ab2b60cdffbf, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var date = _superPropGet($62225008020f0a13$export$b746ab2b60cdffbf, "fromJulianDay", this, 3)([jd]);
      var era = $62225008020f0a13$var$findEraFromGregorianDate(date);
      return new (0, $35ea8db9cb2ccb90$export$99faa760c7908e4f)(this, $62225008020f0a13$var$ERA_NAMES[era], date.year - $62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return _superPropGet($62225008020f0a13$export$b746ab2b60cdffbf, "toJulianDay", this, 3)([$62225008020f0a13$var$toGregorian(date)]);
    }
  }, {
    key: "balanceDate",
    value: function balanceDate(date) {
      var gregorianDate = $62225008020f0a13$var$toGregorian(date);
      var era = $62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
      if ($62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
        date.era = $62225008020f0a13$var$ERA_NAMES[era];
        date.year = gregorianDate.year - $62225008020f0a13$var$ERA_ADDENDS[era];
      }
      // Constrain in case we went before the first supported era.
      this.constrainDate(date);
    }
  }, {
    key: "constrainDate",
    value: function constrainDate(date) {
      var idx = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
      var end = $62225008020f0a13$var$ERA_END_DATES[idx];
      if (end != null) {
        var _end = _slicedToArray(end, 3),
          endYear = _end[0],
          endMonth = _end[1],
          endDay = _end[2];
        // Constrain the year to the maximum possible value in the era.
        // Then constrain the month and day fields within that.
        var maxYear = endYear - $62225008020f0a13$var$ERA_ADDENDS[idx];
        date.year = Math.max(1, Math.min(maxYear, date.year));
        if (date.year === maxYear) {
          date.month = Math.min(endMonth, date.month);
          if (date.month === endMonth) date.day = Math.min(endDay, date.day);
        }
      }
      if (date.year === 1 && idx >= 0) {
        var _$62225008020f0a13$va = _slicedToArray($62225008020f0a13$var$ERA_START_DATES[idx], 3),
          startMonth = _$62225008020f0a13$va[1],
          startDay = _$62225008020f0a13$va[2];
        date.month = Math.max(startMonth, date.month);
        if (date.month === startMonth) date.day = Math.max(startDay, date.day);
      }
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return $62225008020f0a13$var$ERA_NAMES;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra(date) {
      // Get the number of years in the era, taking into account the date's month and day fields.
      var era = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
      var cur = $62225008020f0a13$var$ERA_START_DATES[era];
      var next = $62225008020f0a13$var$ERA_START_DATES[era + 1];
      if (next == null)
        // 9999 gregorian is the maximum year allowed.
        return 9999 - cur[0] + 1;
      var years = next[0] - cur[0];
      if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
      return years;
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      return _superPropGet($62225008020f0a13$export$b746ab2b60cdffbf, "getDaysInMonth", this, 3)([$62225008020f0a13$var$toGregorian(date)]);
    }
  }, {
    key: "getMinimumMonthInYear",
    value: function getMinimumMonthInYear(date) {
      var start = $62225008020f0a13$var$getMinimums(date);
      return start ? start[1] : 1;
    }
  }, {
    key: "getMinimumDayInMonth",
    value: function getMinimumDayInMonth(date) {
      var start = $62225008020f0a13$var$getMinimums(date);
      return start && date.month === start[1] ? start[2] : 1;
    }
  }]);
}((0, $3b62074eb05584b2$export$80ee6245ec4f29ec));
function $62225008020f0a13$var$getMinimums(date) {
  if (date.year === 1) {
    var idx = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
    return $62225008020f0a13$var$ERA_START_DATES[idx];
  }
}
export { $62225008020f0a13$export$b746ab2b60cdffbf as JapaneseCalendar };